<template>
  <div>
    <!-- 拜访统计 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center p-b-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">应发工资</span>
      </div>

      <div class="flex row-between col-center p-10" style="border-bottom: 1px solid #d4d5de;">
        <div class="flex col-center">
          <img alt="" class="w-28 h-28 m-r-28" src="@/assets/icon/employeeKanban/tablelogo.png">
          <div class="font-28">应发工资</div>
        </div>
        <div class="font-28 font-weight-700">{{ boardData.salary?.actualWages }}元</div>
      </div>
      <div class="flex row-between col-center p-10" style="border-bottom: 1px solid #d4d5de;">
        <div class="flex col-center">
          <img alt="" class="w-28 h-28 m-r-28" src="@/assets/icon/employeeKanban/tablelogo.png">
          <div class="font-28">平均月工资</div>
        </div>
        <div class="font-28 font-weight-700">{{ boardData.salary?.averageWages }}元</div>
      </div>
    </div>

    <!-- 绩效 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center p-b-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">绩效</span>
      </div>

      <div class="flex row-between col-center">
        <div class="width-49 text-center bg-E2EEFC p-24 b-r-8">
          <img alt="" class="w-60 h-55 m-b-20" src="@/assets/icon/employeeKanban/kaohejixiao.png">
          <div class="font-36 font-weight-700">{{ boardData.performance?.averageScore }}</div>
          <div class="font-24 m-t-8 m-b-20">平均绩效分</div>
          <div class="font-24 cor-66">部门排名 第{{ boardData.performance?.performanceScoreRank }}名/共{{ boardData?.unitUserNum }}人</div>
        </div>
        <div class="width-49">
          <div class="flex-col p-20 bg-ECE9F0 m-b-20 b-r-8">
            <img alt="" class="w-36 h-45" src="@/assets/icon/employeeKanban/zuigao.png">
            <div class="flex row-between col-center">
              <span class="font-24">最高绩效分（{{ boardData.performance?.maxScoreMonth }}月）</span>
              <span class="font-36 font-weight-700">{{ boardData.performance?.maxScore }}</span>
            </div>
          </div>
          <div class="flex-col p-20 bg-FFEDCF b-r-8">
            <img alt="" class="w-36 h-45" src="@/assets/icon/employeeKanban/zuidi.png">
            <div class="flex row-between col-center">
              <span class="font-24">最低绩效分（{{ boardData.performance?.minScoreMonth }}月）</span>
              <span class="font-36 font-weight-700">{{ boardData.performance?.minScore }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 扣款统计 -->
    <div class="bg-FF b-r-8">
      <div class="flex space-between col-center p-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">扣款统计</span>
      </div>
      <div>
        <div class="flex col-center bg-FFE6C7 p-16 m-l-16 m-r-16">
          <img alt="" class="w-72 h-72 m-r-16" src="@/assets/icon/employeeKanban/koukuan.png">
          <div class="flex row-between col-center width-90">
            <span class="dis-in-b font-24">扣款总金额</span>
            <span class="dis-in-b font-36 font-weight-700">{{ boardData.deduction?.totalDeduction }}<span class="font-24"> 元</span></span>
          </div>
        </div>
        <div class="flex flex-wrap p-b-20">
          <div class="m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24" style="width: 45.4%">
            <div class="w-72 h-72 m-r-16">
              <img alt="item.label" class="width-100 height-100" src="@/assets/icon/employeeKanban/geshui.png">
            </div>
            <div>
              <div class="font-40 font-weight-700">{{ boardData.deduction?.taxDeduction }}<span class="font-24"> 元</span></div>
              <div class="font-24">个税扣款</div>
            </div>
          </div>
          <div class="m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24" style="width: 45.4%">
            <div class="w-72 h-72 m-r-16">
              <img alt="公积金扣款" class="width-100 height-100" src="@/assets/icon/employeeKanban/gongjijin.png">
            </div>
            <div>
              <div class="font-40 font-weight-700">{{ boardData.deduction?.fundDeduction }}<span class="font-24"> 元</span></div>
              <div class="font-24">公积金扣款</div>
            </div>
          </div>
          <div class="m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24" style="width: 45.4%">
            <div class="w-72 h-72 m-r-16">
              <img alt="社保扣款" class="width-100 height-100" src="@/assets/icon/employeeKanban/shebao.png">
            </div>
            <div>
              <div class="font-40 font-weight-700">{{ boardData.deduction?.socialDeduction }}<span class="font-24"> 元</span></div>
              <div class="font-24">社保扣款</div>
            </div>
          </div>
          <div class="m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24" style="width: 45.4%">
            <div class="w-72 h-72 m-r-16">
              <img alt="其他扣款" class="width-100 height-100" src="@/assets/icon/employeeKanban/qita.png">
            </div>
            <div>
              <div class="font-40 font-weight-700">{{ boardData.deduction?.otherDeduction }}<span class="font-24"> 元</span></div>
              <div class="font-24">其他扣款</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TitleLogo from "@/components/TitleLogo.vue";

export default {
  components: {TitleLogo},
  props: {
    boardData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {}
}
</script>
<style lang="less">
</style>

